"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RichTextRenderer = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var renderParagraph = function renderParagraph(block) {
  var props = {
    style: {},
    className: ""
  };

  if (block.data.textAlign) {
    props.style["textAlign"] = block.data.textAlign;
  }

  if (block.data.className) {
    props.className = block.data.className;
  }

  return /*#__PURE__*/_react.default.createElement("p", Object.assign({}, props, {
    className: (0, _classnames.default)("rte-block-paragraph", props.className),
    dangerouslySetInnerHTML: {
      __html: block.data.text
    }
  }));
};

var renderDelimiter = function renderDelimiter() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "rte-block-delimiter"
  });
};

var renderHeader = function renderHeader(block) {
  var props = {
    style: {},
    className: ""
  };

  if (block.data.textAlign) {
    props.style["textAlign"] = block.data.textAlign;
  }

  if (block.data.className) {
    props.className = block.data.className;
  }

  switch (block.data.level) {
    case 1:
      return /*#__PURE__*/_react.default.createElement("h1", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h1"),
        dangerouslySetInnerHTML: {
          __html: block.data.text
        }
      }));

    case 2:
      return /*#__PURE__*/_react.default.createElement("h2", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h2"),
        dangerouslySetInnerHTML: {
          __html: block.data.text
        }
      }));

    case 3:
      return /*#__PURE__*/_react.default.createElement("h3", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h3"),
        dangerouslySetInnerHTML: {
          __html: block.data.text
        }
      }));

    case 4:
      return /*#__PURE__*/_react.default.createElement("h4", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h4"),
        dangerouslySetInnerHTML: {
          __html: block.data.text
        }
      }));

    case 5:
      return /*#__PURE__*/_react.default.createElement("h5", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h5"),
        dangerouslySetInnerHTML: {
          __html: block.data.text
        }
      }));

    case 6:
      return /*#__PURE__*/_react.default.createElement("h6", Object.assign({}, props, {
        className: (0, _classnames.default)(props.className, "rte-block-heading rte-block-heading--h6"),
        dangerouslySetInnerHTML: {
          __html: block.data.text
        }
      }));

    default:
      return null;
  }
};

function renderImage(block) {
  return /*#__PURE__*/_react.default.createElement("img", {
    className: "rte-block-image",
    alt: block.data.caption,
    src: block.data.file
  });
}

function renderList(block) {
  switch (block.data.style) {
    case "unordered":
      return /*#__PURE__*/_react.default.createElement("ul", {
        className: "rte-block-list"
      }, block.data.items.map(function (text, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i
        }, text);
      }));

    case "ordered":
      return /*#__PURE__*/_react.default.createElement("ol", {
        className: "rte-block-list"
      }, block.data.items.map(function (text, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: i
        }, text);
      }));

    default:
      return null;
  }
}

function renderQuote(block) {
  return /*#__PURE__*/_react.default.createElement("blockquote", {
    className: "rte-block-blockquote"
  }, /*#__PURE__*/_react.default.createElement("p", null, block.data.text));
}

var defaultRenderers = {
  delimiter: renderDelimiter,
  header: renderHeader,
  image: renderImage,
  list: renderList,
  paragraph: renderParagraph,
  quote: renderQuote
};

var RichTextRenderer = function RichTextRenderer(props) {
  // Combine default renderers with custom renderers
  var renderers = Object.assign({}, defaultRenderers, props.renderers);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, props.data.map(function (block, index) {
    var renderer = renderers[block.type];

    if (!renderer) {
      return null;
    }

    var node = renderer(block);

    if ( /*#__PURE__*/_react.default.isValidElement(node)) {
      return /*#__PURE__*/_react.default.cloneElement(node, {
        key: index
      });
    }

    return null;
  }));
};

exports.RichTextRenderer = RichTextRenderer;